import React, { Component } from "react";
import { connect } from "react-redux";
import * as messagingActions from "../../../_actions/messagingActions";
import * as appActions from "../../../_actions/appActions";
import InfiniteScroll from "react-infinite-scroller";
import Scrollbars from "react-custom-scrollbars";
import { map } from "lodash";
import Chat from "./Chat";
import getConversations from "../../../_selectors/messagingSelectors/getConversations";
import getSelectedChatId from "../../../_selectors/messagingSelectors/getSelectedChatId";
import getConversationsLastResult from "../../../_selectors/messagingSelectors/getConversationsLastResult";
class RightSidebar extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selectedChatId !== null) {
      return { isChatOpen: true };
    } else {
      return { isChatOpen: false };
    }
  }
  state = { isChatOpen: false, hasMoreItems: false, chatOpenId: null };
  componentDidMount() {
    const { getListOfConversations } = this.props;

    getListOfConversations();
  }
  componentWillUnmount() {
    const { clear } = this.props;
    clear();
  }
  renderItems = () => {
    const { conversations, initializeChatForUser } = this.props;
    return map(conversations, item => {
      return (
        <li key={item.messagingId}>
          <a
            onClick={() => {
              initializeChatForUser({ ...item });
            }}
            className={
              item.user
                ? item.user.status === "online"
                  ? "status online"
                  : "status away"
                : "status away"
            }
          >
            <img src={item.user.imageURL} title={item.user.name} />{" "}
            {item.user.name}
          </a>
        </li>
      );
    });
  };
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { isChatOpen } = this.state;
    const { lastResult, closeRightBar } = this.props;
    return (
      <div className="dev-page-rightbar">
        <div
          className={
            isChatOpen ? "rightbar-chat rightbar-chat-opened" : "rightbar-chat"
          }
        >
          <div className="rightbar-chat-frame-contacts scroll">
            <Scrollbars style={{ height: "100vh" }}>
              <div className="rightbar-title">
                <h3>Messages</h3>
                <a
                  onClick={() => {
                    closeRightBar();
                  }}
                  className="btn btn-default btn-rounded rightbar-close pull-right"
                >
                  <span className="fa fa-times" />
                </a>
              </div>

              <InfiniteScroll
                pageStart={0}
                loadMore={this.loadMoreItems}
                hasMore={lastResult !== null}
                loader={
                  <div
                    className="loader"
                    style={{
                      textAlign: "center",
                      lineHeight: "50px",
                      color: "#000",
                      fontSize: "1.5em",
                      marginTop: "1em"
                    }}
                  >
                    Please Wait
                  </div>
                }
                useWindow={false}
                initialLoad={false}
              >
                <ul className="contacts">
                  <li className="title">Connected Members</li>
                  {this.renderItems()}
                </ul>
              </InfiniteScroll>
            </Scrollbars>
          </div>
          {isChatOpen ? (
            <Chat
              onChatClose={() => {
                this.setState({ isChatOpen: false });
              }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  conversations: getConversations(state),
  selectedChatId: getSelectedChatId(state),
  lastResult: getConversationsLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getListOfConversations: payload =>
    dispatch(messagingActions.getConversations(payload)),
  initializeChatForUser: payload =>
    dispatch(messagingActions.initializeChat(payload)),
  clear: () => dispatch(messagingActions.clearConversations()),
  loadMore: payload =>
    dispatch(messagingActions.loadMoreConversations(payload)),
  closeRightBar: () => dispatch(appActions.toggleRightbar(false))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSidebar);



// WEBPACK FOOTER //
// ./src/_components/Layout/RightSidebar/index.js